// extracted by mini-css-extract-plugin
module.exports = {"ball":"BasketBall_ball__1MrC8","line1":"BasketBall_line1__2wYhB","line2":"BasketBall_line2__3UQ7N"};